import QuestionAnswerIcon from './QuestionAnswerIcon';

export default QuestionAnswerIcon;
